import React from 'react'
import { range } from 'ramda'
import Box from '../Box'

const FakeLoaderBox = ({ numberItems, withWarnings }) => range(0, numberItems).map(item => <Box key={item} withWarnings={withWarnings} />)

export default FakeLoaderBox
